module.exports = __webpack_public_path__ + "static/media/tm-colorit-6.c7ca0200.webp";